var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mdb-card',{staticClass:"text-left"},[_c('mdb-card-header',{attrs:{"color":"warning-color text-white"}},[_c('h5',[_c('mdb-icon',{attrs:{"icon":"bomb"}}),_vm._v("Error")],1)]),_vm._v(" "),_c('mdb-card-body',[_vm._v("\n      "+_vm._s(_vm.error.response.data)+"  ("+_vm._s(_vm.error.response.status)+")\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }